import { render, staticRenderFns } from "./MsinAddEditMtrl.vue?vue&type=template&id=0cbc6481&scoped=true&"
import script from "./MsinAddEditMtrl.vue?vue&type=script&lang=js&"
export * from "./MsinAddEditMtrl.vue?vue&type=script&lang=js&"
import style0 from "./MsinAddEditMtrl.vue?vue&type=style&index=0&id=0cbc6481&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc6481",
  null
  
)

export default component.exports